import { getTargetLangManualFont } from '@/utils/ls';
import i18n from '@/locales/i18n';

const { t } = i18n.global;

export const createMappingTable = (list, keyField = 'value') => {
  return list.reduce((map, item) => {
    map[item[keyField]] = item;
    return map;
  }, {});
};

export const targetLanguageList = [
  { value: 'KOR', label: '韩国语', human: true, defaultFont: 'ff-GmarketSansMedium' },
  { value: 'JPN', label: '日本语', defaultFont: 'ff-FamiljenGrotesk-Regular' },
  { value: 'RUS', label: '俄语', defaultFont: '' },
  { value: 'ENG', label: '英语', defaultFont: 'ff-NotoSans-Bold-5' },
  { value: 'FRA', label: '法语', defaultFont: '' },
  { value: 'DEU', label: '德语', defaultFont: '' },
  { value: 'HUN', label: '匈牙利语', defaultFont: '' },
  { value: 'ITA', label: '意大利语', defaultFont: '' },
  { value: 'PLK', label: '波兰语', defaultFont: '' },
  { value: 'CSY', label: '捷克语', defaultFont: '' },
  { value: 'NLD', label: '荷兰语', defaultFont: '' },
  { value: 'PTB', label: '葡萄牙语(巴西)', defaultFont: '' },
  { value: 'ROM', label: '罗马尼亚语', defaultFont: '' },
  { value: 'ESP', label: '西班牙语', defaultFont: '' },
  { value: 'TRK', label: '土耳其语', defaultFont: '' },
  { value: 'VIN', label: '越南语', defaultFont: '' },
  { value: 'CHS', label: '中文(简体)', defaultFont: 'ff-HarmonyOS_Sans_SC_Regular' },
  { value: 'CHT', label: '中文(繁體)', defaultFont: 'ff-HarmonyOS_Sans_TC_Regular' },
  { value: 'AR', label: '阿拉伯语', defaultFont: '' },
  { value: 'ID', label: '印尼语', defaultFont: '' },
  { value: 'TH', label: '泰语', defaultFont: '' },
  { value: 'MS', label: '马来语', defaultFont: '' },
  { value: 'TL', label: '他加禄语(菲律宾)', defaultFont: '' },
  { value: 'JW', label: '爪哇语', defaultFont: '' },
  { value: 'MY', label: '缅甸语', defaultFont: '' },
  { value: 'BG', label: '保加利亚语', defaultFont: '' },
];

export const targetLanguageMap = createMappingTable(targetLanguageList);

export const getDefaultFont = lang => {
  // 优先localstorage，然后是预设，最后鸿蒙
  const result = getTargetLangManualFont(lang) || targetLanguageMap[lang]?.defaultFont || 'ff-HarmonyOS_Sans_Regular';
  return result;
};

export const sourceLanguageList = [
  { value: 'CHS', label: '简体中文' },
  { value: 'CHT', label: '繁体中文' },
  { value: 'ENG', label: '英语' },
  { value: 'JPN', label: '日本语' },
];
